<template> 
<div id ="searchBox" class="bsearch">
  <!-- <div class="row">
    {{wordlist}}
  </div> -->
  <div class="search-words">
    <div :class="'sw-' + index" v-for="(item, index) in randomList" :key="index">
      <!-- {{ item }} -->
      <a v-b-tooltip.hover :title="item"  href="#" @click="onSearch(item)">{{ item }}</a>
    </div>
  </div>
  <!-- <div class="search-words">
    <div class="sw-1">Dashboard</div>
    <div class="sw-2">Android App Developer</div>
    <div class="sw-3">Design</div>
    <div class="sw-4">Admin Templates</div>
    <div class="sw-5">Networking</div>
    <div class="sw-6">Corporate</div>
    <div class="sw-7">Microsoft</div>
  </div> -->
  <div class="container search-div">
    <div class="row justify-content-center">
      <div class="col-sm-11 col-md-7">
        <div class="form-group-holder">
          <Autocomplete :resetAfter="false" @tag="addTag" ref="txt_search"
            openDirection="bottom" :searchable="true" :value="searchText"
            :preserveSearch="true" @search-change="getSuggestions" 
            selectLabel = "Search" deselectLabel="Search" selectedLabel="Search"
            tag-placeholder="Search" :taggable="true"
            @select="onSearch" @remove="onSearch" :optionsLimit="5"
            :placeholder="$t('common.labels.SearchPlaceHolder')" 
            :options="suggestions"  id="example-text-input"> 
          </Autocomplete>
        </div>
      </div>
    </div>          
  </div>      
</div>
</template>

<script>
import axios from 'axios'
import Autocomplete from '@/components/autocomplete'
import { EventBus } from '@/main.js'
import { DEFAULT_OBJECT_CATEGORY } from '@/components/common/constants.js'
export default {
  name: 'bannerSearch',
  props: [
    'oldSearchText'
  ],
  components: {Autocomplete},
  data () {
    return {
      searchPlaceholder: 'aaa',
      suggestions: [],
      wordlist: [],
      userId: '',
      searchText: '',
      receivedValue: '',
      latitude: 0,
      longitude: 0,
      caseFalse: false,
      defaultOptions: {maximumAge: 0, timeout: 2000, enableHighAccuracy: false}
    }
  },
  methods: {
    isPresentInSuggestions (elementToSearch) {
      var isPresent = false
      // console.log(this.suggestions)
      this.suggestions.forEach(function (element) {
        if (element === elementToSearch) {
          isPresent = true
        }
      })
      return isPresent
    },
    addTag (newTag) {
      if (!this.isPresentInSuggestions(newTag)) {
        this.suggestions.unshift(newTag)
      }
      this.searchText = newTag
      this.onSearch(newTag)
    },
    errorQuery () {
      // alert(this.searchText)
      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        this.$store.dispatch('getSearchResult', {'searchText': this.searchText, 'location': {'coordinates': [0, 0]}, 'userId': this.userId}).then(response => {
          this.$store.dispatch('fetchSearchCategory').then(response => {
            EventBus.$emit('searchEvent', this.searchText)
            this.$router.push({
              name: 'searchPageAlt',
              params: {
                search: this.searchText
              }
            })
          }, error => {
            console.log('error in fetching category', error)
          })
        }, error => {
          console.log('error in setting search data:', error)
        })
      }
    },
    sendQuery () {
      // alert(this.searchText)
      // console.log('in sendQuery')
      if (this.searchText !== undefined && this.searchText !== null && this.searchText.length !== 0) {
        this.$store.dispatch('getSearchResult', {'searchText': this.searchText, 'location': {'coordinates': [this.longitude, this.latitude]}, 'userId': this.userId}).then(response => {
          this.$store.dispatch('fetchSearchCategory').then(response => {
            EventBus.$emit('searchEvent', this.searchText)
            this.$router.push({
              name: 'searchPageAlt',
              params: {
                search: this.searchText
              }
            })
          }, error => {
            console.log('error in fetching category', error)
          })
        }, error => {
          console.log('error in setting search data:', error)
        })
      }
    },
    sendSearchQuery (position) {
      // console.log('in sendSearchQuery')
      this.latitude = position.coords.latitude
      this.longitude = position.coords.longitude
      // alert('sendSearchQuery')
      this.sendQuery()
    },
    handleRejection (error) {
      // console.log('in handleRejection')
      switch (error.code) {
        case error.PERMISSION_DENIED:
          // console.log('User denied the request for Geolocation.')
          this.errorQuery()
          break
        case error.POSITION_UNAVAILABLE:
          // console.log('Location information is unavailable.')
          this.errorQuery()
          break
        case error.TIMEOUT:
          // console.log('The request to get user location timed out.')
          this.errorQuery()
          break
        case error.UNKNOWN_ERROR:
          // console.log('An unknown error occurred.')
          this.errorQuery()
          break
      }
    },
    onSearch (val) {
      // console.log('in onSearch')
      // storing search text
      this.searchText = val
      // storing profileId
      if (this.isLoggedIn) {
        var profileDetails = this.$store.getters.getProfileDetails
        if (profileDetails !== null && profileDetails.profileId != null) {
          this.userId = profileDetails.profileId
        }
      }
      // asking permission to get Location
      if (this.caseFalse) {
        // if (navigator.geolocation) {
        // console.log('in permission')
        navigator.geolocation.getCurrentPosition(this.sendSearchQuery, this.handleRejection, this.defaultOptions)
      } else {
        // console.log('Your browser doesn\'t support')
        this.errorQuery()
      }
    },
    getMostSearchedWordList () {
      if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || Object.keys(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
        this.wordlist = []
      } else {
        var bannerSearch = this
        this.$store.dispatch('getMostSearchedWordList').then(function (wordlist) {
          bannerSearch.wordlist = wordlist
        })
      }
    },
    getSuggestions (searchText) {
      var banner = this
      if (searchText.length === 0) {
        this.suggestions = []
        // this.searchText = ''
        return
      } else if (searchText.length >= 2) {
        this.previousSuggestionsForSearchText = searchText
        var contentCategory = ''
        if (this.$store.getters.getProfileDetails === undefined || this.$store.getters.getProfileDetails === null || Object.keys(this.$store.getters.getProfileDetails).length === 0 && this.$store.getters.getProfileDetails.constructor === Object) {
          contentCategory = DEFAULT_OBJECT_CATEGORY
        } else {
          contentCategory = this.$store.getters.getUserJvID(this.$store.getters.getProfileDetails.accountDetails)
        }
        axios.post('o/getSuggestionBasedOnKeyword', {'searchText': searchText}, {headers: {'contentCategory': contentCategory}})
        .then(function (res) {
          if (res.status === 200) {
            // alert(res.data.length)
            banner.suggestions = res.data
            // banner.suggestions.unshift(banner.searchText)
          }
        })
      }
    }
  },
  mounted () {
    // autofocus on search box
    // this.$refs.txt_search.$el.focus()
    // alert(this.oldSearchText)
    if (this.oldSearchText !== undefined && this.oldSearchText.length !== 0 && this.oldSearchText !== null) {
      this.searchText = this.oldSearchText
    }
    this.getMostSearchedWordList()
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    },
    randomList: function () {
      return this.$store.getters.getMostSearchedWordList.sort(function () { return 0.5 - Math.random() })
    }
    // suggestions () {
    //   var suggestionsList = []
    //   // alert(this.searchText)
    //   // var text = this.searchText
    //   // alert(this.wordlist)
    //   this.wordlist.forEach(word => {
    //     // alert(word)
    //     if (word.indexOf(this.searchText) !== -1) {
    //       suggestionsList.push(word)
    //     }
    //   })
    //   return suggestionsList
    // }
  }
}
</script>

<style src="@/../static/css/vue-multiselect.min.css"></style>
<style lang="scss">
.bsearch{position: relative; box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.2);
  height: 150px;
  background:linear-gradient(to right, #61bfee 0%, #af96fa 100%);
  .search-div{
    position: relative;
    top: 50px;
    .btn-info {
      color: #333;
      background-color: #fff;
      border-color: #fff;
      border-bottom-right-radius: 0px;
      border-top-right-radius: 0px;
      border-right:1px solid #ccc;
    }
    .dropdown-item{font-size:14px; color:#464a4c;
      &:active{background-color:#eee; color:#333;}
    }
    .form-control{padding: 14px 20px; padding-right: 50px; height: 50px; border:none; border-radius: 4px; outline:none; font-size: 14px; box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);
      &:focus {box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.35);
        + .fa-search {color: #000;}
      }
    }
    /*.input-group{
      outline:none;
      box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2);
      .input-group-addon{
         font-size:20px;
         padding-top:10px;
         padding-right:15px;
         border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer; color:darken(#444, 8%); background-color:#fff;
        &:hover, &:active{ .fa{color:#000;}}
      }
    }*/

    .form-group-holder {position: relative; z-index: 10;
      .fa-search {position: absolute; top: 0; right: 0; padding: 0 20px; font-size: 19px; line-height: 50px; color: #555; transition: all 0.2s ease-out;}
    }
  }

  .multiselect {
    &__tags {padding-right: 50px; height: 50px; border: none; border-radius: 3px; box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.2); transition: all 0.2s ease-out;}
    &__select {padding: 4px 12px; width: 50px; text-align: center; transform: rotate(0) !important;
      &:before {top: 0; content: '\f349'; margin: 0; height: 48px; border: none; font-size: 24px; line-height: 40px; font-family: 'Material Design Icons'; transition: all 0.2s ease-out;}
    }
    &__single {margin: 0; padding: 0 10px; font-size: 13px; line-height: 34px;}
    &__input {margin: 0; padding: 0 10px; font-size: 13px; line-height: 34px; font-weight: 400;  background: transparent; box-shadow: none;
      &::placeholder {color: #35495E; opacity: 0.6;}
    }
    &__content-wrapper {border: none; border-top: 1px solid #e0e0e0; border-radius: 0 0 3px 3px; box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);}
    &__option {padding: 12px 20px; font-size: 14px;
      &--highlight {background: #63bef0;
        &:after {background: #63bef0;}
      }
    }

    &.multiselect--active {
      .multiselect__tags {box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.25);}
      .multiselect__select:before {color: #000;}
    }
  }
}

.search-words {display: none;
  [class*="sw-"] {position: absolute; z-index: 5; font-weight: 100; color: rgba(#fff, 0.5);
  width: 25%;
  white-space: nowrap;
  overflow: hidden;
  line-height: 45px;
  text-overflow: ellipsis;
  a{color:#ebeff1}
  }
  .sw-0 {top: 4%; left: 35%; font-size: 24px;}
  .sw-1 {top: 10%; right: 3%; font-size: 24px;}
  .sw-2 {top: 20%; left: 10%; font-size: 30px;}
  .sw-3 {top: 21%; left: 45%; font-size: 24px;}
  .sw-4 {bottom: 26%; left: 3%; font-size: 24px;}
  .sw-5 {bottom: 28%; left: 50%; font-size: 24px;}
  .sw-6 {bottom: 15%; left: 18%; font-size: 48px;}
  .sw-7 {bottom: 16%; right: 18%; font-size: 26px;}
  .sw-8 {bottom: 36%; right: 4%; font-size: 24px;}

}


@media (min-width: 576px) {
.bsearch {
  .multiselect {
    &__single {font-size: 14px}
    &__input {font-size: 14px;}
  }
}
}

@media (min-width: 768px) {
.bsearch {height: 382px;
  .search-div {top: 161px;}
}

.search-words {display: block;}
}
</style>


// WEBPACK FOOTER //
// src/components/home/bannerSearch.vue?0b182f2e